module.exports = __webpack_public_path__ + "static/background-44243f748e50074fcafd149d816ee733.png";